import { useLocation } from "react-router-dom";
import Header from "../../Header/Header";
import CertificateCard from "../CertificateCard/CertificateCard";
import Footer from "../../Footer/Footer";
import IndustriesComponent from "./IndustriesComponent";
import SecondSection from "./SecondSection/SecondSection";
import ThirdSections from "./ThirdSection/ThirdSections";
import Section11A from "./FourthSection/Section11A";
import Section11B from "./FourthSection/Section11B";
import Section10A from "./FifthSection/Section10A";
import SixthSection from "./SixthSection/SixthSection";
import data from "./IndustriesData";
import SevenSection from "./SevenSection/SevenSection";
import { useEffect } from "react";

const IndustriesPage = () => {
  const location = useLocation();
  const index = location.state?.index;  

  useEffect(() => {
    window.scrollTo(0, 0); // ✅ Scroll to top on route load
  }, []);


  return (
    <>
      <Header />
      <main>
        <IndustriesComponent data={data} index={index}/>
        <SecondSection />
        <ThirdSections />
        <Section11A data={data} index={index}/>
        <Section11B data={data} index={index}/>
        <Section10A data={data} index={index}/>
        <SixthSection data={data} index={index}/>
        <SevenSection />

        <CertificateCard />
      </main>
      <Footer />{" "}
    </>
  );
};

export default IndustriesPage;
